import { OpenEnrollmentPeriodDto } from '@zorro/clients';
import { parseDateISO } from '@zorro/shared/formatters';

import { getSelectedOpenEnrollmentPeriod } from '../openEnrollmentPeriods';
import { useMonolithQuery } from './useMonolithQuery';

export function useHasAllowanceModel(
  openEnrollmentPeriods: OpenEnrollmentPeriodDto[] = [],
  employerId?: string
): { hasAllowanceModel: boolean; isFetching: boolean } {
  const selectedOpenEnrollmentPeriod = getSelectedOpenEnrollmentPeriod(
    openEnrollmentPeriods,
    employerId
  );
  const year = selectedOpenEnrollmentPeriod
    ? parseDateISO(selectedOpenEnrollmentPeriod.effectiveFrom).year()
    : undefined;

  const { data = false, isFetching } = useMonolithQuery({
    method: 'allowanceModelControllerCheckAllowanceModelExists',
    params: employerId && year && [employerId, year],
  });

  return { hasAllowanceModel: data, isFetching };
}
